import React from 'react'

const AlphabetCell = ({ text, isPlain, isCipher, isLast, keepSmall, defaultColor, textColor }) => {
  return (
      <div style={{ borderTop: "1px solid black", borderBottom: "1px solid black", borderLeft: "1px solid black", borderRight: isLast ? "1px solid black" : "0 solid black", backgroundColor: isCipher ? "#FF004D" : isPlain ? "#16FF00" : defaultColor, color: isCipher || isPlain ? "white" : textColor, display: "inline-block", textAlign: "center", width: keepSmall ? "30px" : "50px", padding: keepSmall ? "2px" : "8px", margin: "0", transition: "all .8s ease"}}>
          <p style={{margin:0, fontSize: keepSmall? "14px" : "16px"}}>{text}</p>
      </div>
  )
}

AlphabetCell.defaultProps={
    text: "A",
    isPlain: false,
    isCipher: false,
    isLast: false,
    keepSmall: false,
    defaultColor: "white",
    textColor: "black"
}

export default AlphabetCell